import Vue from "vue";
import VueRouter from "vue-router";
import LoginViews from "@/views/LoginViews.vue";
import DashboardView from "@/views/DashboardView.vue";
import store from "@/store";
// UPLOAD IMAGE
import UploadImageProductViews from "@/views/UploadImageProductViews.vue";
// LIST IMAGE UPLOAD  
import ListImageUpload from "@/views/ListImageUploadViews.vue";
// LIST PRODUCT EXISTING
import ListProductExistingViews from "@/views/ListProductExistingViews.vue";
// SETUP
import CompanyViews from "@/views/CompanyViews.vue";
import UsersViews from "@/views/UsersViews.vue";
import MenuViews from "@/views/MenuViews.vue";
import LevelViews from "@/views/LevelViews.vue";
// 404 PAGE NOT FOUND
import PageNotFoundViews from "@/views/PageNotFoundViews.vue";


Vue.use(VueRouter);
const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginViews,
    meta: {
      guest: true,
    },
  },
  {
    path: "*",
    name: "404 Page Not Found",
    component: PageNotFoundViews,
    meta: {
      auth: true,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardView,
    meta: {
      auth: true,
    },
  },
  // UPLOAD IMAGE
  {
    path: "/uploadgambarproduk",
    name: "uploadgambarproduk",
    component: UploadImageProductViews,
    meta: {
      auth: true,
    },
  },
  // LIST IMAGE UPLOAD
  {
    path: "/daftargambarwaiting",
    name: "daftargambarwaiting",
    component: ListImageUpload,
    meta: {
      auth: true,
    },
  },
  {
    path: "/daftargambarapprove",
    name: "daftargambarapprove",
    component: ListImageUpload,
    meta: {
      auth: true,
    },
  },
  {
    path: "/daftargambarreject",
    name: "daftargambarreject",
    component: ListImageUpload,
    meta: {
      auth: true,
    },
  },
  // LIST PRODUCT EXISTING
  {
    path: "/daftarproduk",
    name: "daftarproduk",
    component: ListProductExistingViews,
    meta: {
      auth: true,
    },
  },
  // SETUP
  {
    path: "/users",
    name: "users",
    component: UsersViews,
    meta: {
      auth: true,
    },
  },
  {
    path: "/company",
    name: "company",
    component: CompanyViews,
    meta: {
      auth: true,
    },
  },
  {
    path: "/menu",
    name: "menu",
    component: MenuViews,
    meta: {
      auth: true,
    },
  },
  {
    path: "/level",
    name: "level",
    component: LevelViews,
    meta: {
      auth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["Auth/isAuth"];
  const isGuest = to.matched.some((record) => record.meta.guest);
  const isAuth = to.matched.some((record) => record.meta.auth);

  if (isAuth && !isAuthenticated) {
    return next({ path: "/login" });
  } else if (isGuest && isAuthenticated) {
    return next({ path: "/dashboard" });
  }

  next();
});

export default router;
